import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'book',
		pluralName: 'books',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
